import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import withStyles from "@mui/styles/withStyles";
// @mui/icons-material

// core components
import cardAnalyticsBodyStyle from "assets/jss/material-dashboard-react/components/cardAnalyticsBodyStyle.jsx";

function CardBody({ ...props }) {
  const { classes, className, children, plain, profile, isexercise, ...rest } = props;
  const exerciseclass = (isexercise) ? true:false;
  const cardBodyClasses = classNames({
    [classes.cardBody]: true,
    [className]: className !== undefined
  });
  return (
    <div className={cardBodyClasses} {...rest}>
      {children}
    </div>
  );
}

CardBody.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};

export default withStyles(cardAnalyticsBodyStyle)(CardBody);
